enum CleaningState {
  StartedThisMission = "StartedThisMission",
  StartedPreviously = "StartedPreviously",
  Pending = "Pending",
  PendingAgain = "PendingAgain",
  FailedPreviously = "FailedPreviously",
  CleanedPreviously = "CleanedPreviously",
  CleanedThisMission = "CleanedThisMission",
  FailedThisMission = "FailedThisMission",
}
  
  export default CleaningState;
  